type Item<T> = {
    enabledForRoles: Array<string> | "all"
    disabledForRoles?: Array<[string]>
} & T


export const checkAllowedItemForUserByRole = <T>(userRole: string, item: Item<T>) => {
    try {
        const {enabledForRoles, disabledForRoles} = item;

        if (enabledForRoles === "all") {
            if (disabledForRoles) {
                return !disabledForRoles.some(([role]) => role === userRole);
            }
            return true;
        }

        return enabledForRoles.some(role => role === userRole);
    } catch (e) {
        console.error("Error checking allowed item for user by role: ", e);
        return false;
    }
}